import { fp16ToFp32, uint8BytesToUint16 } from './fp16';

/**
 * Decode the raw fp16 bytes of a DinoImageEmbedding (the response from the
 * ComputeDinoImageEmbedding RPC) into a regular fp32 Float32Array. The
 * caller has already L2-normalized the vector server-side, so the output
 * is ready for cosine similarity / averaging.
 */
export function decodeImageEmbedding(
  embeddingDim: number,
  values: Uint8Array,
): Float32Array {
  const expectedBytes = embeddingDim * 2;

  if (values.byteLength !== expectedBytes) {
    throw new Error(
      `decodeImageEmbedding: expected ${expectedBytes} bytes (${embeddingDim}*2), got ${values.byteLength}`,
    );
  }

  const fp16 = uint8BytesToUint16(values);
  const out = new Float32Array(embeddingDim);

  for (let i = 0; i < embeddingDim; i += 1) {
    out[i] = fp16ToFp32(fp16[i]);
  }

  return out;
}
